import { AssetRestrictionWorkflowItem } from './asset-restriction-workflow-item';
import { AssetScheduleAddWorkflowItem } from './asset-schedule-add-workflow-item';
import { AssetScheduleDeleteWorkflowItem } from './asset-schedule-delete-workflow-item';
import { ContractorCompetencyWorkflowItem } from './contractor-competency-workflow-item';
import { SiteRestrictionWorkflowItem } from './site-restriction-workflow-item';
import { WorkerCompetencyWorkflowItem } from './worker-competency-workflow-item';
import { WorkflowItem } from './workflow-item.model';

export class WorkflowItemFactory {
  public static create(input: any): WorkflowItem {
    try {

      switch (input.workflowType) {
        case 'ASSET_RESTRICTION':
          return new AssetRestrictionWorkflowItem().deserialize(input);
        case 'SITE_RESTRICTION':
          return new SiteRestrictionWorkflowItem().deserialize(input);
        case 'CONTRACTOR_COMPETENCY':
          return new ContractorCompetencyWorkflowItem().deserialize(input);
        case 'WORKER_COMPETENCY':
          return new WorkerCompetencyWorkflowItem().deserialize(input);
        case 'ASSET_BOOKING_REQUEST':
          return new AssetScheduleAddWorkflowItem().deserialize(input);
        case 'ASSET_BOOKING_CANCELLATION':
          return new AssetScheduleDeleteWorkflowItem().deserialize(input);
        default:
          throw new Error(`Workflow Type is not recognised: ${input.workflowType}`);
      }

    } catch (error) {
      console.error('Error in workflow item factory');
      console.error(error);
      throw new Error(error);
    }
  }
};
